import {useQuery} from "@tanstack/react-query";
import {readRevenueByUserByYear} from "../../../../../api/main/DashboardApi";

export const useReadRevenueByUserByYear = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByUserByYear"],
        queryFn: async () => await readRevenueByUserByYear(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
